import styled from 'styled-components';
import ThinDivider from '../../ThinDivider';
import { theme } from '../../../styles/theme';

export const Container = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
`;

export const CenterLine = styled(ThinDivider)`
  position: absolute;
  top: 50%;
  left: 0;
`;

export const Panel = styled.div`
  display: flex;
  position: relative;
  padding-right: 8px;
  padding-left: 8px;
  background-color: ${theme.colors.level1};
`;
